const canUseNavigator = !!(
  (typeof navigator !== 'undefined'
  && navigator.geolocation && navigator.geolocation.getCurrentPosition));

export default canUseNavigator;



// WEBPACK FOOTER //
// ./src/common/canUseNavigator.js